import { useCallback } from "react";

import { authSession } from "../lib/auth-session";
import { currentUserKeys } from "../queries/current-user-queries";
import API from "~/api";
import { queryClient } from "~/store/query-client";

export function useAuth() {
  const clearAuth = useCallback(() => {
    authSession.clear();
    queryClient.removeQueries();
  }, []);

  const logout = useCallback(async () => {
    try {
      await API.auth.logoutWeb();
    } finally {
      clearAuth();
    }
  }, [clearAuth]);

  const login = useCallback(async (email: string, password: string) => {
    const res = await API.auth.loginWeb({ email, password });
    if (!res.ok) {
      throw res.error;
    }

    authSession.setAuthenticated(res.data.token, res.data.data.id);
    queryClient.setQueryData(
      currentUserKeys.detail(res.data.data.id),
      res.data.data,
    );
  }, []);

  return {
    clearAuth,
    login,
    logout,
  };
}
